import { gql } from '@apollo/client';

export const MERGE_PICKUP_APPOINTMENTS = gql`
    mutation MergePickupAppointments($input: MergePickupAppointmentInput!) {
        mergePickupAppointments(input: $input)
    }
`;

export interface MergePickupAppointmentInput {
    appointmentIds: number[];
    cooperationWarehouseId: number;
    pickupDate: string;
    expectedPickupTimeStart: string;
    expectedPickupTimeEnd: string;
    expectedParcelCount: number;
    expectedParcelUnit: string;
}

export interface MergePickupAppointmentResponse {
    mergePickupAppointments: boolean;
}